export const wordBank = [
  {
    hue: "red",
    words: [
      "apple",
      "crimson",
      "maroon",
      "ruby",
      "firetruck",
      "cherry",
      "strawberry",
      "blood",
      "tomato",
      "ketchup",
    ],
  },
  {
    hue: "orange",
    words: [
      "citrus",
      "sunset",
      "tangy",
      "pumpkin",
      "cheese",
      "carrot",
      "marigold",
      "butter",
      "marmalade",
    ],
  },
  {
    hue: "yellow",
    words: [
      "sunrise",
      "yolk",
      "mustard",
      "pineapple",
      "lemon",
      "banana",
      "bumblebee",
      "corn",
    ],
  },
  {
    hue: "green",
    words: [
      "grass",
      "moss",
      "tortoise",
      "pine",
      "evergreen",
      "emerald",
      "lime",
    ],
  },
  {
    hue: "blue",
    words: [
      "sky",
      "aqua",
      "ocean",
      "navy",
      "denim",
      "blueberry",
      "sapphire",
      "ice",
    ],
  },
  {
    hue: "indigo",
    words: [
      "plum",
      "eggplant",
      "lavender",
      "nebula",
      "concord",
      "iris",
      "raven",
    ],
  },
  {
    hue: "purple",
    words: [
      "royal",
      "regal",
      "grape",
      "eggplant",
      "lilac",
      "tulip",
      "lotus",
      "wine",
    ],
  },
];
